import React from 'react';
import { Section, SectionHeading, Reveal } from './ui/Section';
import { IconLedger, IconStatement, IconChart } from './illustrations/Icons';

const FEATURES = [
  {
    no: '01',
    Icon: IconLedger,
    title: '記帳',
    description: 'AI自動仕訳で業務効率化',
    details: [
      'レシート・請求書の自動読み取り',
      '仕訳の自動提案',
      '勘定科目の自動判定',
    ],
  },
  {
    no: '02',
    Icon: IconStatement,
    title: '決算',
    description: 'ワンクリックで決算書作成',
    details: [
      '財務諸表の自動作成',
      '消費税申告書の自動生成',
      '決算整理仕訳の自動化',
    ],
  },
  {
    no: '03',
    Icon: IconChart,
    title: '集計',
    description: 'リアルタイムで経営状況を把握',
    details: [
      'ダッシュボードで可視化',
      '予実管理・分析機能',
      'カスタムレポート作成',
    ],
  },
];

const Features: React.FC = () => (
  <Section id="features" tone="white">
    <SectionHeading
      eyebrow="Features"
      title="主要機能"
      lead="AIが会計業務を劇的に効率化。記帳から決算まで、ひと続きで完結します。"
    />

    <div className="mt-14 grid gap-6 lg:grid-cols-3">
      {FEATURES.map((f, i) => (
        <Reveal key={f.title} delay={i * 0.1}>
          <div className="card group h-full overflow-hidden transition-shadow duration-300 hover:shadow-card-hover">
            {/* 上部：番号とアイコン */}
            <div className="flex items-start justify-between border-b border-line bg-surface-muted px-8 pt-8 pb-6">
              <div>
                <span className="num text-eyebrow uppercase text-body-faint">{f.no}</span>
                <h3 className="mt-2 text-h3 text-ink-900">{f.title}</h3>
                <p className="mt-1 text-small font-medium text-brand-600">{f.description}</p>
              </div>
              <f.Icon className="h-12 w-12 shrink-0 text-ink-700 transition-transform duration-300 group-hover:scale-105" />
            </div>

            {/* 下部：詳細 */}
            <ul className="space-y-3 px-8 py-7">
              {f.details.map((d) => (
                <li key={d} className="flex gap-3 text-small text-body-DEFAULT">
                  <svg
                    viewBox="0 0 20 20"
                    className="mt-[7px] h-3.5 w-3.5 shrink-0 text-brand-500"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    aria-hidden="true"
                  >
                    <path d="m3 10 5 5 9-11" />
                  </svg>
                  <span className="leading-relaxed">{d}</span>
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
      ))}
    </div>
  </Section>
);

export default Features;
